import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { useLogApplicantActivity } from './hooks';
import { ActivityInLocalStorage } from './types';
import { FormType } from './form';
import { InterviewNowForm } from './InterviewNowForm';
import * as S from './styles';
import { Grid } from 'antd';

export const InterviewNowFromWrapper: React.FC<{
  isPreview?: boolean;
  isPredemo?: boolean;
  jobOfferDetail?: React.ReactNode;
}> = ({ jobOfferDetail, isPreview, isPredemo }) => {
  const [parsedApplication, setParsedApplication] =
    useState<Partial<FormType>>();
  const [loading, setLoading] = useState(true);

  const [activityData, setActivityData] =
    useLocalStorage<ActivityInLocalStorage>('activity');

  const { logActivity, getApplicationActivities, clearApplicationActivities } =
    useLogApplicantActivity(setActivityData);

  useEffect(() => {
    logActivity(activityData)
      .then(parsedApplication => {
        if (parsedApplication || parsedApplication === null) {
          if (parsedApplication) {
            setParsedApplication({
              lastName: parsedApplication.lastName,
              firstName: parsedApplication.firstName,
              phone: parsedApplication.phone,
              email: parsedApplication.email,
            });
          }
          setLoading(false);
        }

        if (jobOfferDetail) {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logActivity]);

  const { sm } = Grid.useBreakpoint();

  return !loading ? (
    <InterviewNowForm
      isPreview={isPreview}
      parsedApplication={parsedApplication}
      isPredemo={isPredemo}
      activity={getApplicationActivities(activityData)}
      clearApplicationActivities={() => clearApplicationActivities}
      jobOfferDetail={jobOfferDetail}
    />
  ) : (
    <S.Wrapper span={24} $fillSpace={!sm} $fullHeight={!isPreview}>
      <S.SkeletonWrapper>
        <S.SkeletonCard active loading={true} />
      </S.SkeletonWrapper>
    </S.Wrapper>
  );
};
